import _defineProperty from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "collapseBehavior", "collapsed"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useTheme } from '../Flowbite/ThemeContext';
import SidebarCollapse from './SidebarCollapse';
import { SidebarContext } from './SidebarContext';
import SidebarCTA from './SidebarCTA';
import SidebarItem from './SidebarItem';
import SidebarItemGroup from './SidebarItemGroup';
import SidebarItems from './SidebarItems';
import SidebarLogo from './SidebarLogo';
var SidebarComponent = function SidebarComponent(_ref) {
  var children = _ref.children,
    _ref$collapseBehavior = _ref.collapseBehavior,
    collapseBehavior = _ref$collapseBehavior === void 0 ? 'collapse' : _ref$collapseBehavior,
    _ref$collapsed = _ref.collapsed,
    isCollapsed = _ref$collapsed === void 0 ? false : _ref$collapsed,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme().theme.sidebar;
  return _jsx(SidebarContext.Provider, {
    value: {
      isCollapsed: isCollapsed
    },
    children: _jsx("aside", _objectSpread(_objectSpread({
      "aria-label": "Sidebar",
      className: classNames(theme.base, theme.collapsed[isCollapsed ? 'on' : 'off']),
      hidden: isCollapsed && collapseBehavior === 'hide'
    }, props), {}, {
      children: _jsx("div", {
        className: theme.inner,
        children: children
      })
    }))
  });
};
SidebarComponent.displayName = 'Sidebar';
export var Sidebar = Object.assign(SidebarComponent, {
  Collapse: SidebarCollapse,
  CTA: SidebarCTA,
  Item: SidebarItem,
  Items: SidebarItems,
  ItemGroup: SidebarItemGroup,
  Logo: SidebarLogo
});